import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        themes: {
            light: {
                primary: '#262262',
                secondary: '#5A3327',
                info: '#4583f4',
                success: '#ebf4d1',
                error: '#e80028'                
            },
            dark: {
                primary: '#262262',
                secondary: '#5A3327',
                info: '#4583f4',
                success: '#509c2c',
                error: '#e80028'
            }
        }
    }
});
